import {useDraggable} from '@dnd-kit/core';
import frameWidth, { percentX, percentY } from './utils';
import useStore from './useStore';

export default function Draggable({id, item}){

    const { selectedItem } = useStore()

    const { attributes, listeners, setNodeRef, transform } = useDraggable({id, data: item});

    const width = frameWidth();

    const fontSize = width * 0.02;

    const padding = fontSize * 0.1;

    const x = item.x + percentX(transform?.x || 0);

    const y = item.y + percentY(transform?.y || 0);

    const style = {
        cursor: 'move',
        fontSize: fontSize,
        padding: padding,
        backgroundColor: 'rgba(255,255,255,0.5)',
        color: 'rgb(50,50,50)',
        border: 'solid 1px',
        borderColor: selectedItem?.id === item.id ? 'black' : 'lightgrey',
        position: 'absolute',
        top: y + '%',
        left: x + '%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999
    }

    return <div 
        id={id} 
        ref={setNodeRef} 
        {...listeners} 
        {...attributes} 
        style={style}
    >
        <span>{item.text}</span>
    </div>

}
